import { FC, PropsWithChildren } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { ProviderProps, TourProvider as _Tour } from '@reactour/tour';
import { cn } from 'utils/helpers';
const TourProvider: FC<PropsWithChildren> = ({ children }) => {
  const disableBody = (target: Element | null) =>
    disableBodyScroll(target as Element, { reserveScrollBarGap: true });
  const enableBody = (target: Element | null) =>
    enableBodyScroll(target as Element);

  const onClickClose: ProviderProps['onClickClose'] = (clickProps) => {
    const { setCurrentStep, steps, setIsOpen, setMeta } = clickProps;
    window.location.href = '/';
    setIsOpen(false);
    setMeta?.('');
    if ((steps?.length as number) > 1) {
      setCurrentStep(0);
    }
  };

  const onClickMask: ProviderProps['onClickMask'] = () => {
    // props.setIsOpen(false);
    // onClickClose(props);
  };

  return (
    <_Tour
      steps={[]}
      disableKeyboardNavigation
      disableDotsNavigation
      padding={{ popover: [10], mask: [1] }}
      showNavigation={false}
      className={cn('font-semibold text-[16px] leading-[22px] text-[#000000]')}
      styles={{
        badge: (base) => ({
          ...base,
          backgroundColor: '#23CC67',
        }),
        maskArea: (base) => ({
          ...base,
          rx: 10,
        }),
        maskWrapper: (base) => ({
          ...base,
          color: '#DEE3E799',
        }),
        close: (base) => ({
          ...base,
          color: '#7E8B99',
          width: 11,
          height: 11,
          top: 12,
          right: 14,
        }),
        popover: (base) => ({
          ...base,
          fontWeight: 600,
          fontSize: 16,
          lineHeight: '22px',
          color: '#000000',
        }),
      }}
      badgeContent={({ currentStep, totalSteps }) =>
        `${currentStep + 1}/${totalSteps}`
      }
      afterOpen={disableBody}
      beforeClose={enableBody}
      onClickClose={onClickClose}
      onClickMask={onClickMask}
    >
      {children}
    </_Tour>
  );
};

export default TourProvider;
